import { useCallback } from 'react';
import { configStore } from 'config/configStore';
import { clearRegulatorSegmentation, clearSegmentation, getVolumes } from '../../rendering/Panels/Renderers/CornerstoneManager';
import { discardSegmentManager } from '../../segmentManager';
import {
  clearEditModeReturnState,
  getEditModeReturnState,
} from '../../analysisModal/EditModel/editModeReturnState';
import { ToolId } from 'config/toolDefinitionsConfig';
import { Series } from '@models/Series';
import { AnalysisType } from 'config/analysisConfig';

export function useCloseModificationMode({
  analysisType,
  selectedSeries,
  selectedSeriesId,
  globalToolState,
  handleManualExit,
  handleUpdateGlobalTool,
  updateCurrentLayout,
  updateSelectAnalysis,
  disableRegulatorConnect,
  setDirty,
}: {
  analysisType: string;
  selectedSeries: unknown;
  selectedSeriesId?: string | null;
  globalToolState: any;
  handleManualExit: () => void;
  handleUpdateGlobalTool: (toolId: ToolId) => void;
  updateCurrentLayout: (layoutType: string) => void;
  updateSelectAnalysis: (series: Series, analysisType: AnalysisType) => void;
  disableRegulatorConnect: () => void;
  setDirty:(value:boolean)=>void;
}) {
  return useCallback(() => {
    const returnState = getEditModeReturnState();
    disableRegulatorConnect();
    discardSegmentManager(setDirty);
    handleManualExit();

    configStore.setData({
      manual3DTool: {
        eraser: false,
        initialPoint: false,
      },
      EditMode: null,
      cprModificationTool: 'none',
    });

    if (analysisType === 'FFR') {
      clearSegmentation(selectedSeriesId, 'manual');
      clearRegulatorSegmentation(selectedSeriesId);
    }

    if (
      returnState &&
      selectedSeries &&
      returnState.seriesId === selectedSeriesId
    ) {
      updateSelectAnalysis(selectedSeries, returnState.analysisType);
      updateCurrentLayout(returnState.layoutType);
      clearEditModeReturnState();
    } else if (analysisType === 'FFR') {
      updateCurrentLayout('ffr');
      clearEditModeReturnState();
    }

    const shouldShowSegmentManager =
      returnState?.seriesId === selectedSeriesId
        ? returnState?.segmentManagerWasActive
        : false;
    if (
      !!globalToolState?.toggles.ToggleSegmentationManager !==
      shouldShowSegmentManager
    ) {
      handleUpdateGlobalTool('ToggleSegmentationManager');
    }
  }, [
    analysisType,
    disableRegulatorConnect,
    globalToolState?.toggles.ToggleSegmentationManager,
    handleManualExit,
    handleUpdateGlobalTool,
    selectedSeries,
    selectedSeriesId,
    updateCurrentLayout,
    updateSelectAnalysis,
  ]);
}
